// src/api/eligibility.js
const API_BASE = String(
  process.env.REACT_APP_API_BASE ||
    process.env.REACT_APP_DASHBOARD_API_BASE ||
    process.env.REACT_APP_TOOLS_API_BASE ||
    process.env.REACT_APP_LAUNCHPAD_BACKEND_URL ||
    ""
)
  .trim()
  .replace(/\/+$/, "");

function buildEligibilityUrl(endpoint) {
  if (!API_BASE) {
    throw new Error(
      "Missing API base env (REACT_APP_API_BASE / REACT_APP_DASHBOARD_API_BASE / REACT_APP_TOOLS_API_BASE)"
    );
  }
  const apiBase = /\/api$/i.test(API_BASE) ? API_BASE : `${API_BASE}/api`;
  return `${apiBase}/${endpoint}`;
}

async function fetchJson(url, opts) {
  const res = await fetch(url, opts);
  const data = await res.json().catch(() => null);

  if (!res.ok || !data || data.ok !== true) {
    const msg = data?.error || `Request failed (${res.status})`;
    throw new Error(msg);
  }
  return data;
}

export function getEligibilityApiBase() {
  return API_BASE;
}

export async function requestEligibilitySignature({ address, signMessageAsync }) {
  if (!address) throw new Error("Missing address");

  const nonceUrl = `${buildEligibilityUrl("nonce")}?address=${encodeURIComponent(address)}&t=${Date.now()}`;
  const nonceResp = await fetchJson(nonceUrl, {
    method: "GET",
    cache: "no-store",
  });

  const signature = await signMessageAsync({
    message: nonceResp.message,
  });

  return { signature, nonceResponse: nonceResp };
}

export async function verifyEligibilitySignature({ address, signature }) {
  if (!address) throw new Error("Missing address");
  if (!signature) throw new Error("Missing signature");

  const res = await fetch(buildEligibilityUrl("eligibility"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    cache: "no-store",
    body: JSON.stringify({ address: String(address).trim(), signature }),
  });
  const data = await res.json().catch(() => null);

  return {
    status: res.status,
    okHttp: res.ok,
    body: data,
  };
}
